module.exports = __webpack_public_path__ + "resources/2cc1620713d1f679e3fdc4ac4880a25d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundmetal.png
// module id = 193
// module chunks = 0